import { render } from "./MailingBlockSocials.vue?vue&type=template&id=414a2d82"
import script from "./MailingBlockSocials.vue?vue&type=script&lang=js"
export * from "./MailingBlockSocials.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__